import Browser from '@wetransfer/concorde-browser';

function getTop(anchor, target, tooltipDimensions, offset) {
  switch (anchor) {
    case 'top':
      return target.top - tooltipDimensions.height - offset;

    case 'right':
    case 'left':
      return target.top + target.height / 2 - tooltipDimensions.height / 2;

    case 'bottom':
    case 'bottom-right':
    case 'bottom-center':
    case 'bottom-left':
      return target.bottom + offset;
  }
}

function getLeft(anchor, target, tooltipDimensions, offset, clientWidth) {
  // These values come from https://github.com/WeTransfer/frontend/blob/master/app/assets/stylesheets/component/poptip.scss
  const hoverArrowWidth = 10;
  const hoverArrowRight = 12;
  const hoverArrowTranslateY = 5;

  switch (anchor) {
    case 'top':
    case 'bottom':
      return target.left + target.width / 2 - tooltipDimensions.width / 2;

    case 'right':
      return target.left - tooltipDimensions.width - offset;

    case 'left':
      return target.right + offset;

    case 'bottom-left':
      return Browser.isMobile
        ? 0
        : target.left -
            (tooltipDimensions.width -
              hoverArrowRight -
              hoverArrowWidth / 2 -
              hoverArrowTranslateY -
              target.width / 2);

    case 'bottom-right':
      return target.left - 2;

    case 'bottom-center':
      return (clientWidth - tooltipDimensions.width) / 2;
  }
}

export function position(elementToPosition, source, offset, anchor) {
  const pos = source.getBoundingClientRect();
  const tooltipDimensions = elementToPosition.getBoundingClientRect();
  const { pageYOffset, pageXOffset } = window;
  const {
    scrollTop,
    clientTop,
    clientWidth,
    scrollLeft,
    clientLeft,
  } = document.documentElement;
  const winTop = (pageYOffset || scrollTop) - clientTop;
  const winLeft = (pageXOffset || scrollLeft) - clientLeft;

  const target = {
    top: pos.top + winTop,
    left: pos.left + winLeft,
    right: pos.right + winLeft,
    bottom: pos.bottom + winTop,
    width: pos.width,
    height: pos.height,
  };

  const top = getTop(anchor, target, tooltipDimensions, offset);
  const left = getLeft(anchor, target, tooltipDimensions, offset, clientWidth);

  elementToPosition.style.top = Math.round(top) + 'px';
  elementToPosition.style.left = Math.round(left) + 'px';
}
